module.exports = {
      id: "trending-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#trending",
      toString: function () {
        return this.url;
      }
    }